import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBjCx-_NubcRhOg9C7CRh62XehfvPDd3Yo",
  authDomain: "supplier-fence-calculator.firebaseapp.com",
  projectId: "supplier-fence-calculator",
  storageBucket: "supplier-fence-calculator.appspot.com",
  messagingSenderId: "538772985242",
  appId: "1:538772985242:web:f6ae6ceb0a8eb0ffe0d623",
};

// init firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
// generate & export auth object
export const auth = getAuth();
